import { FC, useState } from 'react'
import toast from 'react-hot-toast'
import useOrder, { TTrackingState } from '../../hooks/useOrder'
import { IOrder, IOrderItem } from '../../model/IOrder'
import { msg } from '../../msg'
import TrackingWidget from './TrackingWidget'

const TrackingProductWidget: FC<{ orderItem: IOrderItem }> = ({ orderItem }) => {
  const [errState, setErrState] = useState<Partial<Record<keyof TTrackingState, string>>>()
  const { patchAllProductTrackings, loading } = useOrder()
  const [isModal, setIsModal] = useState<boolean>(false)

  const addTracking = async (state: TTrackingState) => {
    setErrState(() => undefined)
    const errs = await patchAllProductTrackings(state, orderItem)
    if (errs) setErrState(() => errs)
    else {
      toast.success(msg('success-tracking-product-adding'), { duration: 5000 })
      setIsModal(() => false)
    }
  }

  return (
    <TrackingWidget
      state={{
        carrier: orderItem?.siCarrier || '',
        trackingNum: orderItem?.siTrackingNum || '',
      }}
      errors={errState}
      loading={loading}
      title={`Edit Tracking Information for Product #${orderItem.id}`}
      buttonTitle={`Edit Tracking Information`}
      buttonActionTitle={`Edit Tracking Information for Product`}
      onClick={addTracking}
      isShown={isModal}
      setIsShown={setIsModal}
    />
  )
}

export default TrackingProductWidget
